<template>
  <main
    class="text-white relative z-30 h-full flex justify-center items-center"
  >
    <Teleport to="body">
      <div
        class="ombre2 fixed inset-0 opacity-40 aspect-square w-full h-full"
      ></div>
    </Teleport>
    <div class="w-full text-center text-white md:-mt-20 xl:-mt-36 mb-8">
      <strong>SOCIÉTÉ ÉDITRICE:</strong><br />
      FERRERO FRANCE COMMERCIALE<br />
      Société par actions simplifiées,<br />
      n°803 769 827 RCS ROUEN<br />
      18 rue Jacques Monod,<br />
      76130 MONT SAINT AIGNAN<br />
      <br />
      <strong>RESPONSABLE DE TRAITEMENT:</strong><br />
      FERRERO FRANCE COMMERCIALE<br />
      Société par actions simplifiées,<br />
      n°803 769 827 RCS ROUEN<br />
      18 rue Jacques Monod,<br />
      76130 MONT SAINT AIGNAN<br />
      <br />
      <strong>HÉBERGEMENT</strong><br />
      Hébergement des données :<br />
      MongoDb Limited Building<br />
      2 Number One Ballsbridge,<br />
      Shelbourne Rd<br />
      Ballsbridge, Dublin 4,<br />
      DO4 Y3X9, Irlande<br />
      Téléphone : +35319014654<br />
      Email : support@mongodb.com<br />
      <br />
      <strong>Localisation des centres de données :</strong><br />
      Les données sont hébergées<br />
      dans les centres situées en France par :<br />
      Amazon Web Service (AWS)<br />
    </div>
  </main>
</template>
<script>
import Teleport from "vue2-teleport";

export default {
  components: {
    Teleport,
  },
};
</script>
<style scoped>
strong {
  @apply font-veneer text-xl;
}

main {
  @apply font-neue text-lg;
}

.ombre2 {
  background-image: url("@/assets/images/flou-min.png");
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
